import { AbstractControl, FormArray, ValidationErrors } from '@angular/forms';

// The 4P grid needs at least one cell written in before the assessment can go on (the review asks for this to be decided; the
// default is that it is required).
export function atLeastOneNote(control: AbstractControl): ValidationErrors | null {
  const rows = (control as FormArray).controls;
  return rows.length === 0 || rows.some((row) => String(row.get('notes')?.value ?? '').trim()) ? null : { atLeastOneNote: true };
}

// The four entries of one symptom cluster row.
type SymptomValue = {
  clientPresentation?: string;
  interventionRecommendations?: string;
  currentProblemImpactRating: number | null;
  interventionImpactRating: number | null;
};

// A symptom cluster row has something in it when any of its four entries is filled.
export function symptomValueUsed(value: SymptomValue): boolean {
  return (
    !!value.clientPresentation?.trim() ||
    !!value.interventionRecommendations?.trim() ||
    value.currentProblemImpactRating !== null ||
    value.interventionImpactRating !== null
  );
}

// A symptom cluster row may be left empty; one that has anything in it needs both of its ratings.
export function symptomRowComplete(group: AbstractControl): ValidationErrors | null {
  const value = group.value as SymptomValue;
  return !symptomValueUsed(value) || (value.currentProblemImpactRating !== null && value.interventionImpactRating !== null) ? null : { ratingsRequired: true };
}
